import consumer from './cable';

$(document).ready(() => {
  if (!$("#exportOperationsBtn").length) {
    return null
  };

  const $exportOperationsBtn = $("#exportOperationsBtn");
  const $exportContainer = $("#export-entries");
  const $noExportRow = $("#no-exports");
  const $newExportRow = $("#newExportRow")

  const addNewExportRow = (exportData) => {
    let new_export_row = $newExportRow.clone();
    new_export_row.attr("id", `exportRow${exportData.export_id}`);
    new_export_row.find("#export-date").html(exportData.created_at);
    new_export_row.find("#export-status-badge").addClass(exportData.badge_color_class)
    new_export_row.find("#export-status-text").html(exportData.status);
    new_export_row.removeClass("d-none");
    $exportContainer.prepend(new_export_row);
  }

  consumer.subscriptions.create(
    {
      channel: "ExportOperationsChannel",
      profile_id: $exportOperationsBtn.data("profile-id")
    }, {
    received(data) {
      if ($noExportRow.length) {
        $noExportRow.remove();
      }
      if (data.generating) {
        addNewExportRow(data);
      } else {
        const $exportRowEl = $(`#exportRow${data.export_id}`);
        $exportRowEl.find("#export-status-badge").removeClass("text-dark bg-warning-100")
        $exportRowEl.find("#export-status-badge").addClass(data.badge_color_class);
        $exportRowEl.find("#export-status-text").html(data.status);
        if (data.success) {
          $exportRowEl.find("#export-document").html(`<a href="${data.export_url}">Télécharger l'export</a>`);
        } else {
          $exportRowEl.find("#export-document").html("");
        }
      }
    }
  }
  );
});
